import { render, staticRenderFns } from "./OrganStatistics.vue?vue&type=template&id=7082c330&scoped=true&"
import script from "./OrganStatistics.vue?vue&type=script&lang=js&"
export * from "./OrganStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7082c330",
  null
  
)

export default component.exports